import { Box, Typography, Button, Stack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function NotFound() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        bgcolor: "background.default",
        color: "text.primary",
        px: 2,
      }}
    >
      <Typography variant="h1" fontWeight="bold" gutterBottom>
        404
      </Typography>
      <Typography variant="h5" gutterBottom>
        Oops! The page you're looking for doesn’t exist.
      </Typography>

      <Stack direction="row" spacing={2} mt={3}>
        <Button
          variant="contained"
          component={RouterLink}
          to="/"
        >
          Go Home
        </Button>
        <Button
          variant="outlined"
          component={RouterLink}
          to="/contact"
        >
          Contact Support
        </Button>
      </Stack>
    </Box>
  );
}



